var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2802_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.52 30.17L0.5 21.67C0.5 20.11 1.75 18.85 3.31 18.85L11.27 18.83C12.83 18.83 14.08 17.56 14.08 16.01L14.05 3.36C14.05 1.8 15.3 0.54 16.86 0.54L29.97 0.5C31.53 0.5 32.79 1.75 32.79 3.31L32.82 16.42C32.82 17.98 31.57 19.24 30.01 19.24L17.44 19.27C15.88 19.27 14.63 20.54 14.63 22.09L14.65 30.13C14.65 31.69 13.4 32.95 11.84 32.95L3.34 32.97C1.79 32.98 0.53 31.73 0.52 30.17Z",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2802_313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.32,
    height: 33.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.4ac766ccbbcfd88ea3183380402ab16a.svg";
export { ForwardRef as ReactComponent };